import { createAction, props } from '@ngrx/store';

export const valueChanged = createAction('Value Changed', props<{ fontsizeValue: number }>());
export const fontsizeChanged = createAction('Font Size Changes', props<{ fontsize: number }>());

export type FontResizerActions = ReturnType<typeof valueChanged | typeof fontsizeChanged>;
